import React from 'react'

import { twowheel, fourwheel, rwd } from '../../compiledSVG/icon'
import Error from '../../generic/Error'
import RadioIconToggle from '../../generic/toggles/radioIconToggle'
import IneligibleError from '../../generic/IneligibleError'

export default ({
  drivetrains,
  drivetrain,
  updateVehicleProp,
  isError,
  isIneligible,
  isDisabled,
  kbbUrl,
  isAdmin,
  isDigitalRetail,
  isCobrandDR,
  vin,
  year,
  make,
  model,
  trim,
  mileage,
  offerCode,
  isAssigned,
  isIneligibleVehiclesEnabled,
  isVehicleGrounded
}) => {
  const svgsMaps = {
    '2WD': twowheel,
    FWD: twowheel,
    AWD: fourwheel,
    '4WD': fourwheel,
    RWD: rwd
  }
  let svgs = drivetrains.map(d => (svgsMaps[d.displayName] ? svgsMaps[d.displayName] : twowheel))

  return (
    <>
      <RadioIconToggle
        id={'drivetrain'}
        textArray={drivetrains}
        valueProp={'drivetrainId'}
        isDisabled={isIneligible || isDisabled}
        Svgs={svgs}
        selectedIndex={drivetrain && drivetrains.findIndex(dt => dt.displayName === drivetrain.displayName)}
        onClickItem={index => updateVehicleProp('drivetrain', drivetrains[index].drivetrainId)}
        isError={isError}
        showIsDefault={true}
      />
      {!isIneligible && <Error isError={isError} id={'drivetrain-error'} text={'Please select your drivetrain.'} />}
      {drivetrain && (
        <IneligibleError
          isError={drivetrain.isIneligible && (isIneligibleVehiclesEnabled ? !isAssigned : true)}
          detail="drivetrain"
          isAdmin={isAdmin}
          kbbUrl={kbbUrl}
          isOfferCodeTcOffer={offerCode && offerCode.toUpperCase() === 'TC'}
          {...{ vin, year, make, model, trim, mileage, isDigitalRetail, isCobrandDR }}
        />
      )}
    </>
  )
}
